import { useState } from "react";
import { MenuItem, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Controller } from "react-hook-form";
import { FormTabs } from "./FormTabs";

const AuthenticationOptions = [
  {
    value: "UserAuthentication",
    label: "User Authentication",
  },
  {
    value: "ServiceAuthentication",
    label: "Service Authentication",
  },
];

const tabConfig = {
  RefreshToken: {
    tab1: "Refresh token",
    tab2: "Azure Key vault",
    type: "text",
  },
  ClientSecret: {
    tab1: "Client Secret",
    tab2: "Azure Key vault",
    type: "text",
  },
};

export default function BigQueryForm({ register, errors, control }) {
  const [authType, setAuthType] = useState("UserAuthentication");
  const handleChangeAuthType = (e) => {
    setAuthType(e.target.value);
  };

  return (
    <>
      <Grid size={12}>
        <TextField
          fullWidth
          size="small"
          label="Description"
          minRows={2}
          maxRows={4}
          multiline
          variant="outlined"
          {...register("Description")}
          // defaultValue={connectionData?.Description}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          fullWidth
          size="small"
          label="Project ID"
          {...register("projectid", { required: true })}
          error={errors.projectid}
          // defaultValue={connectionData?.projectid}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          fullWidth
          size="small"
          label="Additional Project IDs"
          {...register("additionalPIDs")}
          // defaultValue={connectionData?.additioanalPIDs}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="authenticationType"
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              size="small"
              select
              label="Authentication"
              {...register("authenticationType", {
                required: true,
              })}
              {...field}
              onChange={handleChangeAuthType}>
              {AuthenticationOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
      {authType === "UserAuthentication" ? (
        <>
          <Grid size={12}>
            <TextField
              fullWidth
              size="small"
              label="Client ID"
              {...register("ClientId", { required: true })}
              error={errors.ClientId}
              // defaultValue={connectionData?.ClientId}
            />
          </Grid>
          <Grid size={12}>
            <FormTabs
              label={tabConfig.ClientSecret}
              register={register}
              errors={errors}
              control={control}
              // formData={connectionData}
            />
          </Grid>
          <Grid size={12}>
            <FormTabs
              label={tabConfig.RefreshToken}
              register={register}
              errors={errors}
              control={control}
              // formData={connectionData}
            />
          </Grid>
        </>
      ) : (
        <>
          <Grid size={12}>
            <TextField
              fullWidth
              size="small"
              label="Email"
              {...register("email", {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid Email",
                },
              })}
              error={Boolean(errors.email)}
              // defaultValue={connectionData?.email}
              helperText={errors?.email?.message ?? " "}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              size="small"
              label="Key File Path"
              {...register("keyfilepath", { required: true })}
              error={errors.keyfilepath}
              // defaultValue={connectionData?.keyfilepath}
            />
          </Grid>
        </>
      )}
    </>
  );
}
